<div class="web-leads-container">
  <!-- Access denied message for users without proper role -->
  <div *ngIf="!canAccessWebLeads()" class="access-denied-container">
    <p-card class="w-full">
      <ng-template pTemplate="header">
        <h2>Access Denied</h2>
      </ng-template>
      <div class="text-center p-6">
        <fa-icon [icon]="icons.solid.faLock" class="text-6xl text-gray-400 mb-4"></fa-icon>
        <h3 class="text-xl font-semibold mb-2">You don't have permission to access Web Leads</h3>
        <p class="text-gray-600">This feature is restricted to Sales Admin users only.</p>
        <p class="text-sm text-gray-500 mt-2">Please contact your administrator if you believe you should have access to this feature.</p>
      </div>
    </p-card>
  </div>

  <!-- Web Leads content for authorized users -->
  <div *ngIf="canAccessWebLeads()">
    <p-card class="w-full">
    <ng-template pTemplate="header">
      <div class="flex justify-between items-center">
        <h2>New Web Leads</h2>
        <div>
          <p-iconfield iconPosition="left">
            <p-inputicon>
              <fa-icon [icon]="icons.solid.faMagnifyingGlass" />
            </p-inputicon>
            <input pInputText type="text" (input)="nonTransferredLeadsTable.filterGlobal($any($event.target)?.value, 'contains')"
              placeholder="Search..." />
          </p-iconfield>
        </div>
      </div>
    </ng-template>
    <p-table 
      #nonTransferredLeadsTable
      [value]="nonTransferredLeads()" 
      [paginator]="true" 
      [rows]="10" 
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 20, 50, 100]"
      [globalFilterFields]="newLeadsFilterFields()"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      styleClass="p-datatable-gridlines flex flex-col w-full"
      [tableStyle]="{'width': '100%', 'table-layout': 'auto'}"
      [scrollable]="true"
      scrollDirection="both">
      <ng-template pTemplate="header">
        <tr>
          @for (col of newLeadscolumns; track col.field) {
            <th [pSortableColumn]="col.field">
              <app-table-header [column]="col"></app-table-header>
            </th>
          }
          <th>Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-lead>
        <tr>
          @for (col of newLeadscolumns; track col.field) {
            <td>
              <app-table-column [column]="col" [data]="lead"></app-table-column>
            </td>
          }
          <td>
            <div class="flex gap-2">
              <app-icon-button 
                [icon]="icons.solid.faCheck" 
                [text]="false" 
                textSize="text-xs"
                (onClick)="assignLead(lead)" 
                pTooltip="Assign" 
                tooltipPosition="bottom"
                [disabled]="lead.status === 'transferred' || lead.status === 'inactive'"
                size="sm"
              >
              </app-icon-button>
              <app-icon-button 
                [icon]="icons.solid.faXmark" 
                [text]="false" 
                textSize="text-xs"  
                (onClick)="deleteLead(lead.id)" 
                pTooltip="Delete" 
                tooltipPosition="bottom"
                buttonType="danger"
                [disabled]="lead.status === 'transferred' || lead.status === 'inactive'"
                size="sm"
              >
              </app-icon-button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>

  <p-card class="w-full">
    <ng-template pTemplate="header">
      <div class="flex justify-between items-center">
        <h2>Last 100 Assigned Leads</h2>
        <div>
          <p-iconfield iconPosition="left">
            <p-inputicon>
              <fa-icon [icon]="icons.solid.faMagnifyingGlass" />
            </p-inputicon>
            <input pInputText type="text" (input)="transferredLeadsTable.filterGlobal($any($event.target)?.value, 'contains')"
              placeholder="Search..." />
          </p-iconfield>
        </div>
      </div>
    </ng-template>
    <p-table 
      #transferredLeadsTable
      [value]="transferredLeads()" 
      [paginator]="true" 
      [rows]="10" 
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 20, 50, 100]"
      [globalFilterFields]="transferredLeadsFilterFields()"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      styleClass="p-datatable-gridlines flex flex-col w-full"
      [tableStyle]="{'width': '100%', 'table-layout': 'auto'}"
      [scrollable]="true"
      scrollDirection="both">
      <ng-template pTemplate="header">
        <tr>
          @for (col of transferredLeadsColumns; track col.field) {
            <th [pSortableColumn]="col.field">
              <app-table-header [column]="col"></app-table-header>
            </th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-lead>
        <tr>
          @for (col of transferredLeadsColumns; track col.field) {
            <td>
              <app-table-column [column]="col" [data]="lead"></app-table-column>
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </p-card>

  <p-card class="w-full">
    <ng-template pTemplate="header">
      <div class="flex justify-between items-center">
        <h2>Last 100 Deleted Leads</h2>
        <div>
          <p-iconfield iconPosition="left">
            <p-inputicon>
              <fa-icon [icon]="icons.solid.faMagnifyingGlass" />
            </p-inputicon>
            <input pInputText type="text" (input)="inactiveLeadsTable.filterGlobal($any($event.target)?.value, 'contains')"
              placeholder="Search..." />
          </p-iconfield>
        </div>
      </div>
    </ng-template>
    <p-table 
      #inactiveLeadsTable
      [value]="inactiveLeads()" 
      [paginator]="true" 
      [rows]="10" 
      [rowsPerPageOptions]="[10, 20, 50, 100]"
      [showCurrentPageReport]="true"
      [globalFilterFields]="inactiveLeadsFilterFields()"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      styleClass="p-datatable-gridlines flex flex-col w-full"
      [tableStyle]="{'width': '100%', 'table-layout': 'auto'}"
      [scrollable]="true"
      scrollDirection="both">
      <ng-template pTemplate="header">
        <tr>
          @for (col of inactiveLeadsColumns; track col.field) {
            <th [pSortableColumn]="col.field">
              <app-table-header [column]="col"></app-table-header>
            </th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-lead>
        <tr>
          @for (col of inactiveLeadsColumns; track col.field) {
            <td>
              <app-table-column [column]="col" [data]="lead"></app-table-column>
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </p-card>
  </div> <!-- Close authorized users section -->
</div> 